<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Company Configuration
    </h5>
  </div>
<div id="mainContent" class="container">
<div class="pt-5 pb-5">
  <div class="col-md-10 offset-md-1">
    <form [formGroup]="modalForm">
      <div class="card">
        <div class="card-header">
          Company Configuration
          <button type="button" class="btn btn-sm btn-light" style="float: right;"
          (click)="toggleEdit()" matTooltip="Click to enable edit" matTooltipPosition="above">
          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </button>
        </div>
        <div class="card card-body" >
          <label class="">Employee Info</label>
          <hr style="margin: 1% 1%;">
          <div class="row">
            <div class="col-md-4">
            <div class="form-group mb-0">
            <label class="mb-0">Emp Working Hours :</label>
            <input id="empWorkingHours" name="empWorkingHours" type="text" class="form-control form-control-xs"
            [class.is-invalid]="formErrors.empWorkingHours && formSubmitted"
            matTooltip="{{formErrors.empWorkingHours}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
            formControlName="empWorkingHours">
            </div>
            </div>

            <div class="col-md-4">
            <div class="form-group mb-0">
            <label class="mb-0">Emp Weekly Working Days :</label>
            <input id="empWeeklyWorkingDays" name="empWeeklyWorkingDays" type="text" class="form-control form-control-xs"
            [class.is-invalid]="formErrors.empWeeklyWorkingDays && formSubmitted"
            matTooltip="{{formErrors.empWeeklyWorkingDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
            formControlName="empWeeklyWorkingDays">
            </div>
            </div>

            <div class="col-md-4">
            <div class="form-group mb-0">
            <label class="mb-0">Emp Monthly Working Days :</label>
            <input id="empMonthlyWorkingDays" name="empMonthlyWorkingDays" type="text" class="form-control form-control-xs"
            [class.is-invalid]="formErrors.empMonthlyWorkingDays && formSubmitted"
            matTooltip="{{formErrors.empMonthlyWorkingDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
            formControlName="empMonthlyWorkingDays">
            </div>
            </div>

            </div>
            <div class="row">
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Emp Monthly Leave Days :</label>
              <input id="empMonthlyLeaveDays" name="empMonthlyLeaveDays" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.empMonthlyLeaveDays && formSubmitted"
              matTooltip="{{formErrors.empMonthlyLeaveDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="empMonthlyLeaveDays">
              </div>
              </div>
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Emp Credit Hours :</label>
              <input id="empCreditHours" name="empCreditHours" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.empCreditHours && formSubmitted"
              matTooltip="{{formErrors.empCreditHours}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="empCreditHours">
              </div>
              </div>
            </div>
            <br>
            <label class="">Article Info</label>
            <hr style="margin: 1% 1%;">
            <div class="row">
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Article Working Hours :</label>
              <input id="artWorkingHours" name="artWorkingHours" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.artWorkingHours && formSubmitted"
              matTooltip="{{formErrors.artWorkingHours}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="artWorkingHours">
              </div>
              </div>
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Article Weekly Working Days :</label>
              <input id="artWeeklyWorkingDays" name="artWeeklyWorkingDays" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.artWeeklyWorkingDays && formSubmitted"
              matTooltip="{{formErrors.artWeeklyWorkingDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="artWeeklyWorkingDays">
              </div>
              </div>
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Article Monthly Working Days :</label>
              <input id="artMonthlyWorkingDays" name="artMonthlyWorkingDays" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.artMonthlyWorkingDays && formSubmitted"
              matTooltip="{{formErrors.artMonthlyWorkingDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="artMonthlyWorkingDays">
              </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Article Monthly Leave Days :</label>
              <input id="artMonthlyLeaveDays" name="artMonthlyLeaveDays" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.artMonthlyLeaveDays && formSubmitted"
              matTooltip="{{formErrors.artMonthlyLeaveDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="artMonthlyLeaveDays">
              </div>
              </div>
              <div class="col-md-4">
              <div class="form-group mb-0">
              <label class="mb-0">Article Credit Hours :</label>
              <input id="artCreditHours" name="artCreditHours" type="text" class="form-control form-control-xs"
              [class.is-invalid]="formErrors.artCreditHours && formSubmitted"
              matTooltip="{{formErrors.artCreditHours}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
              formControlName="artCreditHours">
              </div>
              </div>
            </div>
            <hr style="margin: 1% 1%;">
            <div class="row">
              <div class="col-md-9"> </div>
              <div class="col-md-3">
                <button  type="button" *ngIf="modalStatus=='add'" [disabled]="!isEditable" class="btn btn-sm btn-block btn-theme" (click)="onSaveClick()">Save</button>
                <button  type="button" *ngIf="modalStatus=='edit'" [disabled]="!isEditable" class="btn btn-sm btn-block btn-theme" (click)="onUpdateClick()">Update</button>
              </div>
            </div>
        </div>
      </div>
    </form>

  </div>




</div>
</div>
</div>
<!-- Modal Template -->
<!-- <ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Role</h5>
  </div>
  <div class="modal-body">

    <form [formGroup]="modalForm">
      <div class="row">
      <label class="col-sm-4">EmpWorkingHours :</label>
      <div class="col-sm-8">
      <input id="empWorkingHours" name="empWorkingHours" type="text" class="form-control form-control-xs"
      [class.is-invalid]="formErrors.empWorkingHours && formSubmitted"
      matTooltip="{{formErrors.empWorkingHours}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
      formControlName="empWorkingHours">
      </div>
      </div>

      <div class="row">
      <label class="col-sm-4">EmpWeeklyWorkingDays :</label>
      <div class="col-sm-8">
      <input id="empWeeklyWorkingDays" name="empWeeklyWorkingDays" type="text" class="form-control form-control-xs"
      [class.is-invalid]="formErrors.empWeeklyWorkingDays && formSubmitted"
      matTooltip="{{formErrors.empWeeklyWorkingDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
      formControlName="empWeeklyWorkingDays">
      </div>
      </div>

      <div class="row">
      <label class="col-sm-4">EmpMonthlyWorkingDays :</label>
      <div class="col-sm-8">
      <input id="empMonthlyWorkingDays" name="empMonthlyWorkingDays" type="text" class="form-control form-control-xs"
      [class.is-invalid]="formErrors.empMonthlyWorkingDays && formSubmitted"
      matTooltip="{{formErrors.empMonthlyWorkingDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
      formControlName="empMonthlyWorkingDays">
      </div>
      </div>

      <div class="row">
      <label class="col-sm-4">EmpMonthlyLeaveDays :</label>
      <div class="col-sm-8">
      <input id="empMonthlyLeaveDays" name="empMonthlyLeaveDays" type="text" class="form-control form-control-xs"
      [class.is-invalid]="formErrors.empMonthlyLeaveDays && formSubmitted"
      matTooltip="{{formErrors.empMonthlyLeaveDays}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
      formControlName="empMonthlyLeaveDays">
      </div>
      </div>

      <div class="row">
      <label class="col-sm-4">EmpCreditHours :</label>
      <div class="col-sm-8">
      <input id="empCreditHours" name="empCreditHours" type="text" class="form-control form-control-xs"
      [class.is-invalid]="formErrors.empCreditHours && formSubmitted"
      matTooltip="{{formErrors.empCreditHours}}" matTooltipPosition="above" matTooltipClass="warn-tooltip"
      formControlName="empCreditHours">
      </div>
      </div>


    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
        <div class="col-sm-6"></div>
        <div class="col-sm-3">
            <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
        <div class="col-sm-3">
            <button  type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
            <button  type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
        </div>
    </div>
</div>
</ng-template> -->
